import { render, staticRenderFns } from "./ReportePerdidasScrap.vue?vue&type=template&id=12d6df22&scoped=true"
import script from "./ReportePerdidasScrap.vue?vue&type=script&lang=js"
export * from "./ReportePerdidasScrap.vue?vue&type=script&lang=js"
import style0 from "./ReportePerdidasScrap.vue?vue&type=style&index=0&id=12d6df22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6df22",
  null
  
)

export default component.exports